<template>
  <div id="tag">
    <div class="row">
      <div class="col-lg-12 col-xl-12 card-body bg_grey">
        <div class="container-tag ml-2 mr-2">
          <div class="aling-justify-center">
            <div class="header-job mt-4 mb-4 aling-justify-center">
              <h4>Etiquetas</h4>
            </div>
          </div>
          <div
            class="card d-flex justify-content-between mb-2"
            v-for="tag in tags"
            :key="tag.id"
            :style="{ backgroundColor: tag.color }"
          >
            <div class="row pt-1 pb-1">
              <div class="col-lg-12 col-xl-12 d-flex">
                <div
                  class="name-tag ml-2 mr-2 ml-2 color-white"
                  @click="selectTag(tag)"
                >
                  {{ tag.name }}
                </div>
                <div class="option-tag d-flex">
                  <div>
                    <span
                      class="pointer color-white ml-2 mr-1"
                      @click="deleteTag(tag.id)"
                    >
                      <i class="fas fa-trash-alt color-white"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
          <div class="center">
            <button
              class="btn btn-primary full mt-1 label-bold"
              @click="openForm"
            >
              CRIAR NOVA ETIQUETA
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagForm from "./TagForm.vue";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  components: { TagForm },
  props: ["apply_id", "candidate_id"],
  mounted() {
    this.getTags();
  },
  data: () => ({
    tags: "",
    tag_apply: {
      apply_id: "",
      tag_id: "",
      color: "",
      candidate_id: "",
    },
  }),
  methods: {
    deleteTag(tag) {
      eventBus.$emit("setTag", tag.color, tag.name);
      let conf = confirm("Tem certeza que deseja deletar essa Etiqueta? ");
      if (!conf) return;
      axios.delete(`/recruiters/tag_applies/${tag}`).then((response) => {});
      axios.delete(`/recruiters/tags/delete/${tag}`).then((response) => {
        this.tags = response.data.tags;
      });
      this.getTags();
    },
    getTags() {
      axios.get("/recruiters/tags").then((response) => {
        this.tags = response.data.tags;
      });
    },
    selectTag(tag) {
      if (!this.apply_id) return;
      axios
        .post("/recruiters/tag_applies/create", {
          tag_apply: {
            color: tag.color,
            tag_id: tag.id,
            apply_id: this.apply_id,
          },
        })
        .then((response) => {
          this.$emit("close");
          this.$toast.success(`Etiqueta selecionada com sucesso ${tag.name}`);
          eventBus.$emit("setTag", tag.color, tag.name);
        });
    },
    openForm() {
      this.$modal.show(
        TagForm,
        {},
        {
          width: "30%",
          height: "auto",
          scrollable: false,
        },
        {
          "before-close": this.getTags,
        }
      );
    },
  },
};
</script>
